import { Menu, X } from "lucide-react";
import { useState } from "react";
import { Brand } from "./Brand";
import { ButtonLink } from "./ButtonLink";

const navItems = [
  ["Care guides", "/articles/"],
  ["How it works", "/how-it-works/"],
  ["About", "/about/"],
  ["Help", "/help/"],
] as const;

export function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="site-header">
      <div className="site-header__inner wrap">
        <Brand />
        <p className="site-header__hours">7 days · 8am–9pm PT</p>
        <button
          className="nav-toggle"
          type="button"
          aria-expanded={menuOpen}
          aria-controls="primary-navigation"
          aria-label={menuOpen ? "Close navigation" : "Open navigation"}
          onClick={() => setMenuOpen((open) => !open)}
        >
          {menuOpen ? <X aria-hidden="true" /> : <Menu aria-hidden="true" />}
        </button>
        <nav
          className={`primary-nav${menuOpen ? " primary-nav--open" : ""}`}
          id="primary-navigation"
          aria-label="Primary navigation"
        >
          <ul className="primary-nav__list">
            {navItems.map(([label, href]) => (
              <li key={href}>
                <a href={href}>{label}</a>
              </li>
            ))}
          </ul>
          <ButtonLink href="/consultation/">Book a consult</ButtonLink>
        </nav>
      </div>
    </header>
  );
}
